module.exports = __webpack_public_path__ + "img/svg/trophy-won.663ca774cb62ff18246a46bffb4b8e1a.svg";